<!-- App.vue -->

<!-- HTML Template -->
<template>
  <div id="upload-list">
        <b-container class="container">
            <b-row style="margin-bottom: 8px">
                <b-col>
                    <h4 v-if="justImages">Your Uploaded Images</h4>
                    <h4 v-else-if="justAudio">Your Uploaded Audio Files</h4>
                    <h4 v-else>Your Uploaded Files</h4>
                </b-col>
                <b-col align-self="end" md="auto">
                    <div v-if="isLoading">
                        Loading files...
                    </div>
                    <div v-else>
                        <b-btn @click="$refs.uploadModal.show()" style="background-color: Transparent; border: none; padding: 0; margin-right: 12px" v-b-tooltip.hover="'upload file'" aria-label="upload file">
                        <i class="fas fa-file-upload fa-2x font-button"></i>
                        </b-btn>
                        <b-btn @click="refresh" style="background-color: Transparent; border: none; padding: 0" v-b-tooltip.hover="'refresh files'" aria-label="refresh files">
                        <i class="fas fa-sync-alt fa-2x font-button"></i>
                        </b-btn>
                    </div>
                </b-col>
             </b-row>
                <div v-if="!isLoading">
                    <div>
                        You have used <b>{{count.numUploads}}</b> out of <b>{{count.maxUploads}}</b> uploads. 
                        <b-btn v-if="!user.isSubscribed && !user.trialing" style="margin-left: 5px" v-b-tooltip="'Subscribing increases the limit to 100'" variant="cliovis-blue-light" size="sm" @click="$refs.subscriptionModal.show()" pill><i class="fas fa-plus"/> Increase Limit</b-btn>
                    </div>
                    <div v-if="uploads.length > 0">
                        <b-row v-for="(upload, index) in uploads" :key="index">
                            <b-col v-if="justImages && isUploadImage(upload)">
                                <b-card>
                                    <b-media>
                                        <h5>{{upload.file_name}}</h5>
                                        <a slot="aside" target="blank" :href="upload.s3_path">
                                            <b-img fluid width="128" :src="upload.s3_path" :alt="upload.file_description"/>
                                        </a>
                                        <p>{{upload.file_description}}</p>
                                        <b-btn v-if="addLink" variant="cliovis-blue-light" @click="addLinkAndClose(upload.s3_path, true)">Add Link</b-btn>
                                        <b-btn v-else variant="cliovis-blue-light" @click="copyToClipboard(upload.s3_path)">Copy Link</b-btn>
                                        <b-btn variant="danger" @click="showDeleteModal(upload)" style="margin-left: 5px" aria-label="delete file"><i class="fas fa-trash" style="margin: 0"></i></b-btn>
                                    </b-media>
                                </b-card>
                            </b-col>
                            <b-col v-else-if="justAudio && !isUploadImage(upload)">
                                <b-card>
                                    <b-media>
                                        <h5>{{upload.file_name}}</h5>
                                        <audio style="margin: auto;" controls="controls">
                                            <source :src="upload.s3_path">
                                            Your browser does not support the HTML5 Audio element.
                                        </audio>
                                        <p>{{upload.file_description}}</p>
                                        <b-btn v-if="addLink" variant="cliovis-blue-light" @click="addLinkAndClose(upload.s3_path, false)">Add Link</b-btn>
                                        <b-btn v-else variant="cliovis-blue-light" @click="copyToClipboard(upload.s3_path)">Copy Link</b-btn>
                                        <b-btn variant="danger" @click="showDeleteModal(upload)" style="margin-left: 5px" aria-label="delete file"><i class="fas fa-trash" style="margin: 0"></i></b-btn>
                                    </b-media>
                                </b-card>
                            </b-col>
                            <b-col v-else-if="!justImages && !justAudio">
                                <b-card>
                                    <b-media>
                                        <h5>{{upload.file_name}}</h5>
                                        <a v-if="isUploadImage(upload)" slot="aside" target="blank" :href="upload.s3_path">
                                            <b-img fluid width="128" :src="upload.s3_path" :alt="upload.file_description"/>
                                        </a>
                                        <audio v-else style="margin: auto;" controls="controls">
                                            <source :src="upload.s3_path">
                                            Your browser does not support the HTML5 Audio element.
                                        </audio>
                                        <p>{{upload.file_description}}</p>
                                        <b-btn variant="cliovis-blue-light" @click="copyToClipboard(upload.s3_path)">Copy Link</b-btn>
                                        <b-btn variant="danger" @click="showDeleteModal(upload)" style="margin-left: 5px" aria-label="delete file"><i class="fas fa-trash" style="margin: 0"></i></b-btn>
                                    </b-media>
                                </b-card>
                            </b-col>
                        </b-row>
                    </div>
                        <div v-else>
                            <b-row>
                                <b-col>
                                    <br/>
                                    <p>You don't have any uploads</p>
                                </b-col>
                            </b-row>
                        </div>
                </div>
            <div v-for="(response, ind) in responses" :key="ind" style="position: sticky; bottom: 5px">
                <div v-if="response.status == 'success'">
                    <b-alert dismissible variant="success" show>{{response.message}}</b-alert>
                </div>
                <div v-else>
                    <b-alert dismissible variant="danger" show>{{response.error}}</b-alert>
                </div>
            </div>
        </b-container>
        <b-modal centered ref="uploadModal" title="Upload File" ok-only ok-variant="secondary" ok-title="Close" size="lg">
			<upload/>
		</b-modal>
        <b-modal centered ref="subscriptionModal" title="Subscribe" ok-only ok-variant="secondary" ok-title="Close" size="wide-3" no-close-on-backdrop no-close-on-esc>
			<subscription-panel/>
		</b-modal>
    </div>
    
</template>

<!-- Javascript -->
<script>
import Vue from 'vue'
import copy from 'copy-to-clipboard'
import Upload from '@/components/Upload.vue'
import SubscriptionPanel from '@/components/payment/SubscriptionPanel.vue'
import PaymentMethodManager from '@/components/payment/PaymentMethodManager.vue'

export default Vue.extend({
    name: 'UploadList',
    components: {
         Upload,
         SubscriptionPanel,
         PaymentMethodManager
    },
    props: {
        addLink:
        {
            type: Boolean,
            default: undefined
        },
        justImages:
        {
            type: Boolean,
            default: undefined
        },
        justAudio:
        {
            type: Boolean,
            default: undefined
        }
    },

    computed: {
        showList()
        {
            if(uploads.length > 0)
            {
                return true;
            }
            else
            {
                return false;
            }            
        }
    },
    data: function()
    {
        return {
            isLoading: false,
            uploads: [],
            responses: [],
            count: {numUploads: 0, maxUploads: 0}
        }
    },
    mounted() {
        this.refresh();        
    },
    methods: {
        async refresh() {
            this.isLoading = true;
            this.uploads.length = 0
            try
            {
                {
                    let count = await this.$http.get("upload/count");
                    this.$set(this, "count", count.data)
                }

                {
                    let response = await this.$http.get("upload")
                    this.$set(this, "uploads", response.data.uploads)
                }
            }
            catch(ex)
            {
                alert(`Failed to fetch uploads: ${ex}`);
            }
            this.isLoading = false;
        },

        isUploadImage(upload) {
            if (upload == null || upload.s3_path == null || upload.s3_path.endsWith == null)
                return true;
            return upload.s3_path.endsWith('.png') || upload.s3_path.endsWith('.jpg') || upload.s3_path.endsWith('.jpeg') || upload.s3_path.endsWith('.gif');
        },

        deleteUpload(id) {
            let form = new FormData();
            form.append("id", id);
            
            this.$http.delete("upload?"+document.cookie, {data: form})
            .then(
                (response)=>{
                    if (response.data.message != null) {
                        this.responses.push(response.data);
                    }
                    this.refresh();
                },
                (error)=>{
                    // TODO: Report error
                    console.log(error.response)
                    let response = error.response
                    if (response.data.error != null) {
                        this.responses.push(response.data);
                    }
                })
            .finally(()=>{
                this.isSaving = false;
            })
        },
        showDeleteModal(upload) {
            // TODO: Replace with bootstrap modal
            if (confirm("Are you sure you want to delete " + upload.file_name + "?")) {
                this.deleteUpload(upload.id)
            }
        },
        copyToClipboard(str) {
            copy(str);
            this.responses.push({status: "success", message: "Copied " + str + " to clipboard!"})
        },
        addLinkAndClose(str, image) {
           
            this.$emit('close', str, image);
        },
        navigate(path) {
            p = new ProfileView;
            p.curTab = 1;
            this.$router.push(path);
        }
    }
})
</script>

<!-- SASS styling -->
<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}

.hide
{
    visibility: hidden!important;
}
</style>
